export enum MacroType {
    Hospitals = 1,
    Location = 2,
    Provider = 3
}
